module.exports = __webpack_public_path__ + "img/missao.7a4562a4.svg";